import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/*GUARDS*/
import { MainGuard } from './guards/main.guard';
import { LoginGuard } from './guards/login.guard';




const APP_ROUTES:Routes = [
	{
		path:'',
		children:[
			{
				path: '',
				canActivate: [LoginGuard],
				loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
			},
			{
				path: 'login',
				canActivate: [LoginGuard],
				loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
			},
			{
				path: 'main',
				canActivate: [MainGuard],
				loadChildren: () => import('./pages/main/main.module').then(m => m.MainModule)
			}
		]
	},
	{
		path:'**',
		pathMatch: 'full',
		redirectTo: 'main' 
	}
];

@NgModule({
  imports: [RouterModule.forRoot( APP_ROUTES, { useHash: false, scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy', anchorScrolling: 'enabled' } ) ],
  exports: [RouterModule]
})
export class AppRoutingModule { }


